import React from "react"

const LoadingScreen = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  )
}

export default LoadingScreen
